var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,21c-14.888,0-27,12.112-27,27s12.112,27,27,27s27-12.112,27-27S62.888,21,48,21z M48,71c-12.682,0-23-10.317-23-23 c0-12.682,10.318-23,23-23c12.683,0,23,10.318,23,23C71,60.683,60.683,71,48,71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,38.285c2.127,0,3.857,1.73,3.857,3.857c0,1.104,0.896,2,2,2s2-0.896,2-2c0-3.64-2.492-6.702-5.857-7.59v-2.508 c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.508c-3.366,0.888-5.858,3.949-5.858,7.59C40.142,46.475,43.667,50,48,50 c2.127,0,3.857,1.73,3.857,3.857c0,2.128-1.73,3.858-3.857,3.858c-2.127,0-3.858-1.73-3.858-3.858c0-1.104-0.896-2-2-2 s-2,0.896-2,2c0,3.641,2.492,6.702,5.858,7.591v2.507c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.507c3.365-0.888,5.857-3.95,5.857-7.591 C55.857,49.524,52.333,46,48,46c-2.127,0-3.858-1.73-3.858-3.858C44.142,40.015,45.873,38.285,48,38.285z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.10a3e7fb0601329faf7fa848c69fa694.svg";
export { ForwardRef as ReactComponent };